import { Admin, Resource, CustomRoutes } from "react-admin";
import { Route } from "react-router-dom";
 
import DataProvider from "../data/DataProvider";
import authProvider from "../auth/authProvider";
import theme from "./theme";
import MyLayout from "./MyLayout";
import Dashboard from "./Dashboard";
import "./AdminApp.css";
 
import PeopleIcon from "@mui/icons-material/People";
 
import UserList from "../RBAC/users/UserList";
import UserCreate from "../RBAC/users/UserCreate";
import UserEdit from "../RBAC/users/UserEdit";
import UserShow from "../RBAC/users/UserShow";
 
import { GroupList } from "../RBAC/Groups/GroupsList";
import { GroupCreate } from "../RBAC/Groups/GroupsCreate";
import { GroupEdit } from "../RBAC/Groups/GroupsEdit";
import { GroupShow } from "../RBAC/Groups/GroupsShow";
 
import { UserGroupList } from "../RBAC/UserGroups/UserGroupsList";
import { UserGroupCreate } from "../RBAC/UserGroups/UserGroupsCreate";
import { UserGroupEdit } from "../RBAC/UserGroups/UserGroupsEdit";
import { UserGroupShow } from "../RBAC/UserGroups/UserGroupsShow";
 
import { RoleList } from "../RBAC/Roles/RolesList";
import { RoleCreate } from "../RBAC/Roles/RolesCreate";
import { RoleEdit } from "../RBAC/Roles/RolesEdit";
import { RoleShow } from "../RBAC/Roles/RolesShow";
 
import { PermissionList } from "../RBAC/Permission/PermissionList";
import { PermissionCreate } from "../RBAC/Permission/PermissionCreate";
import { PermissionEdit } from "../RBAC/Permission/PermissionEdit";
import { PermissionShow } from "../RBAC/Permission/PermissionShow";
 
import { GroupRoleList } from "../RBAC/GroupRoles/GroupRolesList";
import { GroupRoleCreate } from "../RBAC/GroupRoles/GroupRolesCreate";
import { GroupRoleEdit } from "../RBAC/GroupRoles/GroupRolesEdit";
import { GroupRoleShow } from "../RBAC/GroupRoles/GroupRolesShow";
 
import { RolePermissionList } from "../RBAC/RolePermission/RolePermissionList";
import { RolePermissionCreate } from "../RBAC/RolePermission/RolePermissionCreate";
import { RolePermissionEdit } from "../RBAC/RolePermission/RolePermissionEdit";
import { RolePermissionShow } from "../RBAC/RolePermission/RolePermissionShow";
 
import FormList from "../forms/FormList";
import FormCreate from "../forms/FormCreate";
import FormEdit from "../forms/FormEdit";
import FormPreview from "../forms/FormPreview";

import CourseList from "../Courses/CourseList";
import CourseCreate from "../Courses/CourseCreate";
import CourseEdit from "../Courses/CourseEdit";

import FormTypeList from "../formTypes/FormTypeList";
import FormTypeCreate from "../formTypes/FormTypeCreate";


import MicrosoftLoginPage from "../loginpage/MicrosoftLoginPage";
 
import CertificateList from "../certificate/CertificateList";
import CertificateCreate from "../certificate/CertificateCreate";
import CertificateAssign from "../certificate/CertificateAssign";
import CertificateAssignList from "../certificate/CertificateAssignList";
import { FeedbackSubmissionList } from "../feedback-submission/feedbackSubmissionList";
import { FeedbackSubmissionShow } from "../feedback-submission/feedbackSubmissionShow";
import { FeedbackTypeSummaryList } from "../feedback-submission/feedbackTypeSummaryList"; 


import UserGuideList from "../UserGuide/UserGuideList";
import UserGuideCreate from "../UserGuide/UserGuideCreate";
import UserGuideEdit from "../UserGuide/UserGuideEdit";


import UserGuideAssignmentList from "../UserGuideAssignment/UserGuideAssignmentList";
import UserGuideAssignmentCreate from "../UserGuideAssignment/UserGuideAssignmentCreate";
import AssessmentList from "../assessment/AssessmentList";
import AssessmentCreate from "../assessment/AssessmentCreate";
import AssessmentEdit from "../assessment/AssessmentEdit";
import AssessmentShow from "../assessment/AssessmentShow";    

import CategoryList from "../assessment/CategoryList";
import CategoryCreate from "../assessment/CategoryCreate";
import CategoryEdit from "../assessment/CategoryEdit";
import CategoryShow from "../assessment/CategoryShow";

import QuestionList from "../assessment/QuestionList";
import QuestionCreate from "../assessment/QuestionCreate";
import QuestionEdit from "../assessment/QuestionEdit";
import QuestionShow from "../assessment/QuestionShow";

import AssessmentAssign from "../assessment/AssessmentassignCreate";
import AssessmentAssignList from "../assessment/AssessmentassignList";
import AssessmentResponseList from "../assessment/AssessmentresponseList";
import AssessmentResponseShow from "../assessment/AssessmentresposeShow";

 
const AdminApp = () => (
  console.log("inside the admin app after clicking login"),
  <Admin
  dataProvider={DataProvider}
  authProvider={authProvider}
  theme={theme}
  darkTheme={{ palette: { mode: "dark" } }}
  layout={MyLayout}
    dashboard={Dashboard}
    loginPage={MicrosoftLoginPage}
    >
    <CustomRoutes>
      <Route path="/forms/:id/preview" element={<FormPreview />} />
    </CustomRoutes>

    {(permissions = []) => {
      console.log("Rendering AdminApp with authProvider and DataProvider",permissions)
      
  const isSuperAdmin =
    permissions.includes("*") ||
    permissions.includes("*.*");

  const hasGlobalRead =
    permissions.includes("*.read") ||
    permissions.includes("read.*");

  return (
    <>
      {/* 🔥 SUPER ADMIN */}
      {isSuperAdmin && (
      
            <>
              <Resource name="certificate" list={CertificateList} create={CertificateCreate} />
              
              <Resource name="assign-certificate" list={CertificateAssignList} create={CertificateAssign} />
              
              <Resource
  name="courses"
  list={CourseList}
  create={CourseCreate}
  edit={CourseEdit}
/>

<Resource
  name="user-guides"
  list={UserGuideList}
  create={UserGuideCreate}
  edit={UserGuideEdit}
/>

<Resource
  name="user-guide-assignments"
  list={UserGuideAssignmentList}
  create={UserGuideAssignmentCreate}
/>
<Resource
  name="categories"
  list={CategoryList}
  create={CategoryCreate}
  edit={CategoryEdit}
  show={CategoryShow}
/>

<Resource
  name="questions"
  list={QuestionList}
  create={QuestionCreate}
  edit={QuestionEdit}
  show={QuestionShow}
/>

<Resource
  name="assessments"
  list={AssessmentList}
  create={AssessmentCreate}
 
  show={AssessmentShow}
/>
<Resource
  name="assignments"
  list={AssessmentAssignList}
  create={AssessmentAssign}
/>
<Resource name="all_attempts"
 list={AssessmentResponseList}
show={AssessmentResponseShow} />   



              <Resource name="forms" list={FormList} create={FormCreate} edit={FormEdit} show={FormPreview}/>
              <Resource name="feedback-submissions" list={FeedbackSubmissionList} show={FeedbackSubmissionShow}/>
              <Resource name="form-types" list={FormTypeList} create={FormTypeCreate}  />
              
              <Resource name="feedback-type-summary" list={FeedbackTypeSummaryList} />
              <Resource name="users" icon={PeopleIcon} list={UserList} create={UserCreate} edit={UserEdit} />
              <Resource name="groups" list={GroupList} create={GroupCreate} edit={GroupEdit} />
              <Resource name="permissions" list={PermissionList} create={PermissionCreate} edit={PermissionEdit} />
              <Resource name="roles" list={RoleList} create={RoleCreate} edit={RoleEdit} />
              <Resource name="usergroups" list={UserGroupList} create={UserGroupCreate} edit={UserGroupEdit} />
              <Resource name="grouproles" list={GroupRoleList} create={GroupRoleCreate} edit={GroupRoleEdit} />
              <Resource name="rolepermissions" list={RolePermissionList} create={RolePermissionCreate} edit={RolePermissionEdit} />
            </>
          )}

          {/* 👀 GLOBAL READ */}
          {hasGlobalRead && !permissions.includes("*") && (
            <>
            <CustomRoutes>
                <Route path="/forms/:id/preview" element={<FormPreview />} />
              </CustomRoutes>
              <Resource name="categories" list={CategoryList} show={CategoryShow} create={CategoryCreate}edit={CategoryEdit} />
              <Resource name="questions" list={QuestionList} show={QuestionShow}  create={QuestionCreate} edit={QuestionEdit}/>
             <Resource
  name="assessments"
  list={AssessmentList}
  show={AssessmentShow}
  create={AssessmentCreate}
  {...(permissions.includes("create") && { create: AssessmentCreate })}
/> <Resource name="certificate" list={CertificateList}  />
              <Resource name="user-guides" list={UserGuideList}  />
              <Resource name="user-guide-assignments" list={UserGuideAssignmentList} />
              <Resource name="courses" list={CourseList} create={CourseCreate} edit={CourseEdit} />
              
            <Resource name="assign-certificate" list={CertificateList} />
              <Resource name="forms" list={FormList} show={FormPreview}/>
              <Resource name="form-types" list={FormTypeList} />
              <Resource name="feedback-submissions" list={FeedbackSubmissionList} show={FeedbackSubmissionShow}/>
              <Resource name="feedback-type-summary" list={FeedbackTypeSummaryList}/>

              <Resource name="users" icon={PeopleIcon} list={UserList} show={UserShow} />
              <Resource name="groups" list={GroupList} show={GroupShow} />
              <Resource name="roles" list={RoleList} show={RoleShow} />
              <Resource name="permissions" list={PermissionList} show={PermissionShow} />
              <Resource name="usergroups" list={UserGroupList} show={UserGroupShow} />
              <Resource name="grouproles" list={GroupRoleList} show={GroupRoleShow} create={GroupRoleCreate} edit={GroupRoleEdit} />
              <Resource name="rolepermissions" list={RolePermissionList} show={RolePermissionShow} create={RolePermissionCreate}edit={RolePermissionEdit} />
            </>
          )}

          {/* ✅ NORMAL RBAC USERS */}
          {!hasGlobalRead && !permissions.includes("*") && (
            <>
             {(permissions.includes("assessments.*") ||
                permissions.includes("assessments.read") ||
                permissions.includes("assessments.create") ||
                permissions.includes("assessments.edit")) && (
                <Resource
                  name="assessments"
                  list={AssessmentList}
                  create={
                    permissions.includes("assessments.create") ||
                    permissions.includes("assessments.*")
                      ? AssessmentCreate
                      : undefined
                  }
                  edit={
                    permissions.includes("assessments.edit") ||
                    permissions.includes("assessments.*")
                      ? AssessmentEdit                     
                      : undefined
                  }
                  show={
                    permissions.includes("assessments.read") ||
                    permissions.includes("assessments.*")
                      ? AssessmentShow
                      : undefined
                  }
                />
              )}
             {(permissions.includes("assessments.*") ||
                permissions.includes("assessments.read") ||
                permissions.includes("assessments.create") ||
                permissions.includes("assessments.edit")) && (
                <Resource
                  name="categories"
                  list={CategoryList}
                  create={
                    permissions.includes("assessments.create") ||
                    permissions.includes("assessments.*")
                      ? CategoryCreate
                      : undefined
                  }
                  edit={
                    permissions.includes("assessments.edit") ||
                    permissions.includes("assessments.*")
                      ? CategoryEdit                     
                      : undefined
                  }
                  show={
                    permissions.includes("assessments.read") ||
                    permissions.includes("assessments.*")
                      ? CategoryShow
                      : undefined
                  }
                />
              )}
             {(permissions.includes("assessments.*") ||
                permissions.includes("assessments.read") ||
                permissions.includes("assessments.create") ||
                permissions.includes("assessments.edit")) && (
                <Resource
                  name="questions"
                  list={QuestionList}
                  create={
                    permissions.includes("assessments.create") ||
                    permissions.includes("assessments.*")
                      ? QuestionCreate
                      : undefined
                  }
                  edit={
                    permissions.includes("assessments.edit") ||
                    permissions.includes("assessments.*")
                      ? QuestionEdit                     
                      : undefined
                  }
                  show={
                    permissions.includes("assessments.read") ||
                    permissions.includes("assessments.*")
                      ? QuestionShow
                      : undefined
                  }
                />
              )}
             {(permissions.includes("user-guides.*") ||
                permissions.includes("user-guides.read") ||
                permissions.includes("user-guides.create") ||
                permissions.includes("user-guides.edit")) && (
                <Resource
                  name="user-guides"
                  list={UserGuideList}
                  create={
                    permissions.includes("user-guides.create") ||
                    permissions.includes("user-guides.*")
                      ? UserGuideCreate
                      : undefined
                  }
                  edit={
                    permissions.includes("user-guides.edit") ||
                    permissions.includes("user-guides.*")
                      ? UserGuideEdit                     
                      : undefined
                  }
                />
              )}
              {(permissions.includes("user-guides.*") ||
                permissions.includes("user-guides.read") ||
                permissions.includes("user-guides.create") ||
                permissions.includes("user-guides.edit")) && (
                <Resource
                  name="courses"
                  list={CourseList}
                  create={
                    permissions.includes("user-guides.create") ||
                    permissions.includes("user-guides.*")
                      ? CourseCreate
                      : undefined
                  }
                  edit={
                    permissions.includes("user-guides.edit") ||
                    permissions.includes("user-guides.*")
                      ? CourseEdit                     
                      : undefined
                  }
                  
                />
              )}


              {(permissions.includes("user-guides.*") ||
                permissions.includes("user-guides.read") ||
                permissions.includes("user-guides.create") ||
                permissions.includes("user-guides.edit")) && (
                <Resource
                  name="user-guide-assignments"
                  list={UserGuideAssignmentList}
                  create={
                    permissions.includes("user-guides.create") ||
                    permissions.includes("user-guides.*")
                      ? UserGuideAssignmentCreate
                      : undefined
                  }
                  
                />
              )}

              {(permissions.includes("forms.*") ||
                permissions.includes("forms.read") ||
                permissions.includes("forms.create") ||
                permissions.includes("forms.edit")) && (
                <Resource
                  name="forms"
                  list={FormList}
                  create={
                    permissions.includes("forms.create") ||
                    permissions.includes("forms.*")
                      ? FormCreate
                      : undefined
                  }
                  edit={
                    permissions.includes("forms.edit") ||
                    permissions.includes("forms.*")
                      ? FormEdit
                      : undefined
                  }
                   show={
                    permissions.includes("forms.read") ||
                    permissions.includes("forms.*")
                      ? FormPreview
                      : undefined
                  }
                />
              )}
              {(permissions.includes("forms.*") ||
                permissions.includes("forms.read") ||
                permissions.includes("forms.create") ||
                permissions.includes("forms.edit")) && (
                <Resource
                  name="feedback-submissions"
                  list={FeedbackSubmissionList}
                  
                  
                   show={
                    permissions.includes("forms.read") ||
                    permissions.includes("forms.*")
                      ? FeedbackSubmissionShow
                      : undefined
                  }
                />
              )}
              {(permissions.includes("forms.*") ||
                permissions.includes("forms.read") ||
                permissions.includes("forms.create") ||
                permissions.includes("forms.edit")) && (
                <Resource
                  name="feedback-type-summary"
                  list={FeedbackTypeSummaryList}
                  create={
                    permissions.includes("forms.create") ||
                    permissions.includes("forms.*")
                      ? FeedbackSubmissionList
                      : undefined
                      
                  }

                />
              )}
              {(permissions.includes("certificate.*") ||
                permissions.includes("certificate.read") ||
                permissions.includes("certificate.create") ||
                permissions.includes("certificate.edit")) && (
                <Resource
                  name="certificate"
                  list={CertificateList}
                  create={
                    permissions.includes("certificate.create") ||
                    permissions.includes("certificate.*")
                      ? CertificateCreate
                      : undefined
                  }
                />
              )}
                    
              {(permissions.includes("certificate.*") ||
                permissions.includes("certificate.read") ||
                permissions.includes("certificate.create") ||
                permissions.includes("certificate.edit")) && (
                <Resource
                  name="assign-certificate"
                  list={CertificateAssignList}
                  create={
                    permissions.includes("certificate.create") ||
                    permissions.includes("certificate.*")
                      ? CertificateAssign
                      : undefined
                  }
                />
              )}
                    

             {/* form types */}

{(permissions.includes("forms.*") ||
                permissions.includes("forms.read") ||
                permissions.includes("forms.create") ||
                permissions.includes("forms.edit")) && (
                <Resource
                  name="form-types"
                  list={FormTypeList}
                  create={
                    permissions.includes("forms.create") ||
                    permissions.includes("forms.*")
                      ? FormTypeCreate
                      : undefined
                  }
                  
                />
              )}




              {(permissions.includes("users.*") ||
                permissions.includes("users.read") ||
                permissions.includes("users.edit") ||
                permissions.includes("users.create")) && (
                <Resource
                  name="users"
                  icon={PeopleIcon}
                  list={UserList}
                  edit={
                    permissions.includes("users.edit") ||
                    permissions.includes("users.*")
                      ? UserEdit
                      : undefined
                  }
                  create={
                    permissions.includes("users.create") ||
                    permissions.includes("users.*")
                      ? UserCreate
                      : undefined
                  }
                />
              )}
              {(permissions.includes("users.*") ||
                permissions.includes("users.read") ||
                permissions.includes("users.edit") ||
                permissions.includes("users.create")) && (
                <Resource
                  name="users"
                  icon={PeopleIcon}
                  list={UserList}
                  edit={
                    permissions.includes("users.edit") ||
                    permissions.includes("users.*")
                      ? UserEdit
                      : undefined
                  }
                  create={
                    permissions.includes("users.create") ||
                    permissions.includes("users.*")
                      ? UserCreate
                      : undefined
                  }
                />
              )}
              {(permissions.includes("roles.*") ||
                permissions.includes("roles.read") ||
                permissions.includes("roles.edit") ||
                permissions.includes("roles.create")) && (
                <Resource
                  name="roles"
                  icon={PeopleIcon}
                  list={RoleList}
                  edit={
                    permissions.includes("roles.edit") ||
                    permissions.includes("roles.*")
                      ? RoleEdit
                      : undefined
                  }
                  create={
                    permissions.includes("roles.create") ||
                    permissions.includes("roles.*")
                      ? RoleCreate
                      : undefined
                  }
                />
              )}

              {(permissions.includes("groups.*") ||
                permissions.includes("groups.read") ||
                permissions.includes("groups.edit") ||
                permissions.includes("groups.create")) && (
                <>
                  <Resource
                    name="groups"
                    list={GroupList}
                    edit={
                      permissions.includes("groups.edit") ||
                      permissions.includes("groups.*")
                        ? GroupEdit
                        : undefined
                    }
                    create={
                      permissions.includes("groups.create") ||
                      permissions.includes("groups.*")
                        ? GroupCreate
                        : undefined
                    }
                  />
                </>
              )}

              {(permissions.includes("permissions.*") ||
                permissions.includes("permissions.read") ||
                permissions.includes("permissions.edit") ||
                permissions.includes("permissions.create")) && (
                <Resource
                  name="permissions"
                  list={PermissionList}
                  edit={
                    permissions.includes("permissions.edit") ||
                    permissions.includes("permissions.*")
                      ? PermissionEdit
                      : undefined
                  }
                  create={
                    permissions.includes("permissions.create") ||
                    permissions.includes("permissions.*")
                      ? PermissionCreate
                      : undefined
                  }
                />
              )}
            </>
          )}
        </>
      );
    }}
  </Admin>
);

export default AdminApp;
